export enum MENU {
  PATIENT_LIST = 'patient-list',
  NEW_PATIENT = 'new-patient',
  PATIENT_PROFILE = 'patient-profile',
  SCANNER = 'scanner',
  EXERCISES = 'exercises',
  APPOINTMENTS = 'appointments',
  SETTINGS = 'settings',
  PATIENT_REGISTRATION_QR = 'patient-registration-qr',
}
